const API_BASE = process.env.REACT_APP_API_URL || 'https://itequip.athensservices.com';

class ApiService {
  constructor() {
    this.token = null;
  }

  setToken(token) {
    this.token = token;
  }

  async request(path, options = {}) {
    const url = `${API_BASE}/api${path}`;
    const headers = {
      'Content-Type': 'application/json',
      ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
      ...options.headers,
    };

    const res = await fetch(url, { ...options, headers });

    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: 'Request failed' }));
      throw Object.assign(new Error(err.error || 'Request failed'), { status: res.status });
    }

    return res.json();
  }

  get(path, params) {
    const query = params ? '?' + new URLSearchParams(params).toString() : '';
    return this.request(path + query);
  }

  post(path, body) {
    return this.request(path, { method: 'POST', body: JSON.stringify(body) });
  }

  patch(path, body) {
    return this.request(path, { method: 'PATCH', body: JSON.stringify(body) });
  }

  delete(path, body) {
    return this.request(path, { method: 'DELETE', body: body ? JSON.stringify(body) : undefined });
  }

  // ── Auth ────────────────────────────────────────────────────────────────────
  getMe() { return this.get('/auth/me'); }

  // ── Assets ──────────────────────────────────────────────────────────────────
  getAssets(params) { return this.get('/assets', params); }
  getAsset(id) { return this.get(`/assets/${id}`); }
  createAsset(data) { return this.post('/assets', data); }
  updateAsset(id, data) { return this.patch(`/assets/${id}`, data); }
  retireAsset(id, data) { return this.delete(`/assets/${id}`, data); }
  getAssetMap() { return this.get('/assets/map'); }

  // ── Transfers ────────────────────────────────────────────────────────────────
  createTransfer(data) { return this.post('/transfers', data); }
  getTransfers(params) { return this.get('/transfers', params); }

  // ── Employees ────────────────────────────────────────────────────────────────
  getEmployees(params) { return this.get('/employees', params); }
  getEmployee(id) { return this.get(`/employees/${id}`); }
  getEmployeeAssets(id) { return this.get(`/employees/${id}/assets`); }

  // ── Locations ────────────────────────────────────────────────────────────────
  getLocations(params) { return this.get('/locations', params); }
  getLocationGroups() { return this.get('/locations/groups'); }

  // ── Damage ───────────────────────────────────────────────────────────────────
  getDamageReports(params) { return this.get('/damage', params); }
  createDamageReport(data) { return this.post('/damage', data); }
  updateDamageReport(id, data) { return this.patch(`/damage/${id}`, data); }

  // ── Reports ──────────────────────────────────────────────────────────────────
  getTerminationReport() { return this.get('/reports/terminations'); }
  getExpiringLicenses(params) { return this.get('/reports/licenses-expiring', params); }
  getDamageSummary(params) { return this.get('/reports/damage-summary', params); }
  getUnassignedAssets() { return this.get('/reports/unassigned'); }
  getAssetsByLocation() { return this.get('/reports/assets-by-location'); }

  // ── Sync ─────────────────────────────────────────────────────────────────────
  runHexnodeSync() { return this.post('/sync/hexnode', {}); }
  getHexnodeDetail(id) { return this.get('/assets/' + id + '/hexnode-detail'); }
  getHexnodeSyncHistory() { return this.get('/sync/hexnode/history'); }
  runVerizonImport(rows) { return this.post('/sync/verizon', { rows }); }
  getVerizonHistory() { return this.get('/sync/verizon/history'); }
  runNinjaSync() { return this.post('/sync/ninja', {}); }
  getNinjaSyncHistory() { return this.get('/sync/ninja/history'); }
  runHexnodeEnrich() { return this.post('/sync/hexnode/enrich', {}); }
  getSyncStatus(params) { return this.get('/sync/status', params); }
  previewWorkdaySync(data) { return this.post('/sync/workday/preview', data); }
  runWorkdaySync(data) { return this.post('/sync/workday', data); }
  runWorkdayAutoSync() { return this.post('/sync/workday/auto', {}); }
}

export const api = new ApiService();
